import React from 'react';
import './PressReleases.scss';
import Breadcrumbs from '../components/ui/Breadcrumbs';

const pressReleases = [
  {
    date: '2025-06-03',
    title: `Treatink.com Launches to Empower Veterinarians with Custom-Branded
Treats and Personalized Pet Owner Experience 
<br />
<i>
Veterinary Practices Can Now Offer Clients Unique, Custom-Labeled Pet
Treats Featuring Their Own Pet's Photo— Plus a Branded Online
Storefront</i>`,
    html: `<p>
    Tampa, FL – June 3, 2025 – Treatink.com, a new veterinary-focused product platform, proudly
announces its official launch into the veterinary market. Designed to help veterinarians
strengthen client relationships and deliver memorable experiences, Treatink.com provides
practices with a seamless, turnkey solution to offer custom-labeled pet treats.
</p>
<p>
Unlike traditional e-commerce offerings, Treatink.com focuses on personalized product delivery.
Veterinary clinics can now present branded treat packaging that reinforces their practice’s
identity while allowing pet owners to personalize labels with their pet’s photo—creating a fun
and emotionally resonant customer experience.
</p>
<p>
“Veterinarians are always looking for ways to deepen client loyalty and stand out in a
competitive market,” said Steve Watters, Co-Founder of Treatink.com. “With Treatink.com,
clinics can offer a unique and delightful product that celebrates the bond between pets and
their owners—while reinforcing the veterinary practice’s brand.”
Treatink.com integrates directly with veterinary practices, offering user-friendly access to
custom treat label designs, clinic branding features, and a simple interface for pet owners to
upload pet photos. All treat orders are fulfilled and shipped directly to clients, ensuring a
smooth, hands-off experience for veterinary clinics.
</p>
<p>
New Feature: “Shop-in-Shop” Experience
</p>
<p>
Treatink now enables clinics to launch their own clinic-branded online storefront, where clients
can browse and purchase custom-labeled treats exclusively featuring the clinic’s logo and
messaging. This “shop-in-shop” model empowers veterinary practices to offer a curated, on-
brand product line that enhances client loyalty and boosts ancillary revenue—without managing
inventory or logistics.
    </p>
    <br />
    <h5>Platform Highlights:</h5>
        <ul>
          <li>Clinic-Branded Treat Packaging – Reinforces brand identity.</li>
          <li>Personalized Labels – Featuring client-submitted pet photos.</li>
          <li>Turnkey Fulfillment – Direct-to-client shipping.</li>
          <li>Revenue Share Model – Supports practice growth.</li>
          <li>Client Engagement Tools – Includes marketing assets and order tracking.</li>
          <li>Shop-in-Shop Storefronts – Custom online treat stores under each clinic’s brand.</li>
        </ul>
    <br />

    <p>
    With its nationwide rollout underway, Treatink.com is actively onboarding veterinary practices.
Early adopters receive personalized onboarding, access to customizable design templates, and
promotional materials to engage clients.
“Treatink.com combines veterinary professionalism with joyful personalization,” added Mark
Hammonds, Co-Founder. “We make it easy for clinics to offer something truly special that keeps
clients coming back.”
To learn more or enroll your clinic, visit <a href="www.treatink.com">www.treatink.com</a> or email: <a href="mailto:support@treatink.com">support@treatink.com</a>
    </p>
    <br />

    <h5>About Treatink.com</h5>
    <p>
    Treatink.com is an innovative platform empowering veterinary clinics to offer custom-branded
pet treats with personalized labels. By merging clinic branding with playful personalization,
Treatink.com helps veterinarians build stronger relationships with pet owners while providing a
unique product experience.
    </p>
    `,
  },
];

const breadcrumbs = [
  { label: "Press Releases", link: "/press-releases" },
];

function PressReleases() {
  return (
    <section className="color-swap-container full-width flex flex-col gap-10 items-center pt-5 md:pt-10 text-content">
      <div className="flex flex-col gap-10 contained-width">
        <Breadcrumbs items={breadcrumbs} />
        <div className="flex flex-col gap-5 items-center pb-0 pt-5">
          <h3 className="text-center">Press Releases</h3>
        </div>
      </div>

      <div className="press-releases-cont contained-width same-color">
        {pressReleases.map((release, index) => (
          <div key={index} className="mb-10 p-5 box-shadow bg-white rounded-20">
            <p className="text-3xl color-primary mb-5 font-bold">{release.date}</p>
            <h2
              className="text-xl md:text-4xl text-black font-semibold mb-10"
              dangerouslySetInnerHTML={{ __html: release.title }}
            />
            <div
              className="text-base text-black"
              dangerouslySetInnerHTML={{ __html: release.html }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default PressReleases;
